import { Record } from 'immutable';

export default class InvoiceAddressRecord extends Record({
  id: undefined,
  name: undefined,
  street: undefined,
  street2: undefined,
  postalCode: undefined,
  city: undefined,
  reference: undefined,
}) {
}
